export const NAME = 'tags'

export const TAGS_GET = 'tagsGet'
export const TAGS_POST = 'tagsPost'
export const TAGS_DELETE = 'tagsDelete'

const LOAD_TAGS = 'LOAD_TAGS'
const CHANGE_TAGS = 'CHANGE_TAGS'
const EDIT_TAGS = 'EDIT_TAGS'
const UPDATING_TAGS = 'UPDATING_TAGS'
const UPDATING_TAG_DONE = 'UPDATING_TAG_DONE'

export default [
  LOAD_TAGS,
  CHANGE_TAGS,
  EDIT_TAGS,
  UPDATING_TAGS,
  UPDATING_TAG_DONE,
]
